import { FC } from 'react';

interface HomeContentsStaffProps {}

export const HomeContentsStaff: FC<HomeContentsStaffProps> = () => {
  return (
    <div className="flex flex-col gap-5">
    </div>
  );
};
